import { HttpContextToken } from '@angular/common/http';

export const FFD_NOTES_INVITATION_TOKEN = new HttpContextToken<string | null>(() => null);
export const FFD_NOTES_INVITATION_TWO_FA_TOKEN = new HttpContextToken<string | null>(() => null);
